<template>
  <b-modal hide-footer centered v-model="visible">
    <template #modal-title> Change Status </template>
    <b-form-group
      label-for="status"
      class="w-100 pt-1"
      label="Change the current status"
    >
      <b-button-group class="mt-1">
        <button
          class="btn text-white px-1 mx-25 hover-success"
          :class="status == 'ACCEPTED' ? 'bg-success' : '  '"
          @click="status = 'ACCEPTED'"
        >
          Accepted
        </button>
        <button
          class="btn text-white px-1 mx-25 hover-danger"
          :class="status == 'REJECTED' ? 'bg-danger' : '  '"
          @click="status = 'REJECTED'"
          style="
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
          "
        >
          Rejected
        </button>
        <!-- <button
          class="btn text-white px-1 mx-25 hover-warning"
          :class="status == 'PENDING' ? 'bg-warning' : ' '"
          @click="status = 'PENDING'"
          style="border-top-left-radius: 20px; border-bottom-left-radius: 20px"
        >
          Pending
        </button> -->
        <!-- <button
          class="btn text-white px-1 mx-25 hover-success"
          :class="status == 'ACTIVE' ? 'bg-success' : ' '"
          @click="status = 'ACTIVE'"
          style="border-top-left-radius: 20px; border-bottom-left-radius: 20px"
        >
          Active
        </button> -->
        <button
          class="btn text-white px-1 mx-25 hover-danger"
          :class="status == 'DEACTIVATE' ? 'bg-danger' : ' '"
          @click="status = 'DEACTIVATE'"
          style="border-top-left-radius: 20px; border-bottom-left-radius: 20px"
        >
          Deactive
        </button>
      </b-button-group>
    </b-form-group>
    <b-form-group
      label-for="reason"
      class="w-100"
      label="reason"
      v-if="status == 'REJECTED'"
    >
      <b-form-textarea id="reason" v-model="reason" name="reason" rows="4" />
      <small class="text-danger" v-if="status == 'REJECTED' && !reason"
        >Reason is required</small
      >
    </b-form-group>
    <div class="w-100 d-flex align-items-center justify-content-end">
      <b-button
        @click="changeStatus"
        class="gradient-btn"
        :disabled="
          (currentData.item &&
            currentData.item.status &&
            status == currentData.item.status) ||
          (status == 'REJECTED' && !reason)
        "
      >
        {{
          currentData.item &&
          currentData.item.status &&
          status == currentData.item.status
            ? "Current status"
            : "Change status"
        }}
      </b-button>
    </div>
    <loader :loading="loading" />
  </b-modal>
</template>

<script>
import {
  BModal,
  BFormGroup,
  BButton,
  BButtonGroup,
  BFormTextarea,
} from "bootstrap-vue";
import Loader from "@core/components/loader/Loader.vue";

export default {
  components: {
    BModal,
    BFormGroup,
    BButton,
    BButtonGroup,
    Loader,
    BFormTextarea,
  },
  props: {
    currentData: {
      status: Object,
      default: () => {},
    },
    showChangeStatus: {
      status: Boolean,
      default: false,
    },
  },
  data() {
    return {
      status: "",
      reason: "",
      loading: false,
    };
  },
  computed: {
    visible: {
      get() {
        return this.showChangeStatus;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    currentData(val) {
      this.status = val.item && val.item.status ? val.item.status : "";
      this.reason = val.item && val.item.reason ? val.item.reason : "";
    },
  },
  created() {
    this.status =
      this.currentData.item && this.currentData.item.status
        ? this.currentData.item.status
        : "";
    this.reason =
      this.currentData.item && this.currentData.item.reason
        ? this.currentData.item.reason
        : "";
  },
  methods: {
    async changeStatus() {
      this.loading = true;
      try {
        let status = {
          competition_id: this.currentData.competition_id,
          content: this.currentData.content,
          subject: this.currentData.subject,
          status: this.status,
        };
        this.status == "REJECTED" && (status.reason = this.reason);
        const { data } = await this.$http.post(
          "/panel/partners/" + this.currentData.item.id + "/status",
          status
        );
        this.visible = false;
        this.$emit("updatePartners");
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.btn {
  background-color: #252531;
  border: 1px solid #ffffff0d;
}
@media (min-width: 576px) {
  .modal-dialog {
    width: 560px !important;
  }
}
</style>
